import { RightOutlined } from '@ant-design/icons';
import { PROJECT_STATUS_LABELS } from '@/constants/project';
import type { ProjectListItem } from '@/types/project';

interface MobileProjectCardProps {
  project: ProjectListItem;
  onClick?: () => void;
}

export function MobileProjectCard({ project, onClick }: MobileProjectCardProps) {
  return (
    <article
      className="mobile-card mobile-card--link"
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(event) => {
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
          onClick();
        }
      }}
    >
      <div className="mobile-card__header">
        <span className="mobile-card__title">{project.name}</span>
        <span className="mobile-tag mobile-tag--primary">
          {PROJECT_STATUS_LABELS[project.status]}
        </span>
      </div>
      <div className="mobile-card__meta">
        负责人：{project.projectManager?.name ?? '—'}
      </div>
      <div className="mobile-project-progress">
        <div className="mobile-project-progress__label">
          <span>项目进度</span>
          <span>{project.progress}%</span>
        </div>
        <div className="mobile-project-progress__bar">
          <div
            className="mobile-project-progress__fill"
            style={{ width: `${Math.min(100, Math.max(0, project.progress))}%` }}
          />
        </div>
      </div>
      {onClick ? (
        <div className="mobile-card__footer">
          <span>查看详情</span>
          <RightOutlined />
        </div>
      ) : null}
    </article>
  );
}
